import { render, staticRenderFns } from "./users.vue?vue&type=template&id=66265796&"
import script from "./users.vue?vue&type=script&lang=ts&"
export * from "./users.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports